import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {FileChange} from '@/model/system/storage/FileChange';

import {ISystemStorageService} from '@/services/system/ISystemStorage.service';

@Module({name: 'SystemStorageStore', namespaced: true})
export default class SystemStorageStore extends VuexModule {
  private userChanges: FileChange[] | null = null;
  private userConfigChanges: FileChange[] | null = null;

  @Inject(Symbol.for('ISystemStorageService'))
  private storageService!: ISystemStorageService;

  /* USER */
  @Action({commit: 'setUserChanges', rawError: true})
  public async fetchUserChanges() {
    return await this.storageService.getUserChanges();
  }

  @Mutation
  public setUserChanges(fileChanges: FileChange[]) {
    this.userChanges = fileChanges;
  }

  get UserChanges(): FileChange[] | null {
    return this.userChanges;
  }

  /* USER CONFIG */
  @Action({commit: 'setUserConfigChanges', rawError: true})
  public async fetchUserConfigChanges() {
    return await this.storageService.getUserConfigChanges();
  }

  @Mutation
  public setUserConfigChanges(fileChanges: FileChange[]) {
    this.userConfigChanges = fileChanges;
  }

  get UserConfigChanges(): FileChange[] | null {
    return this.userConfigChanges;
  }
}
